import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useRouter } from 'next/router'

export function useIsPresetFpPageLayout(): boolean {
  const router = useRouter()
  return router.asPath.includes(Routes.PRESET_FP)
}
